import React, { useEffect, useRef, useState } from 'react'
import css from 'styled-jsx/css'
import { Icon, Loading } from 'com-ui2/components'
import { iconPath } from 'com-ui/utilities/imagePath'
import { Button, ChoiceGroup, ValidateControl } from 'com-ui2/controls'
import { experience, investment, PublisherRegister } from 'src/services'
import { useFbp } from 'src/hooks/useFbp'
import { useGtag } from 'src/hooks/useGtag'
import getLogRocket from 'src/components/logrocket/logRocket'
import { useCheckDomain } from 'src/hooks/useCheckDomain'

const optionsExperiences = [
  { label: 'No Experience', key: experience.NO_EXPERIENCE },
  { label: '1 - 6 months', key: experience.LESSS_THAN_SIX_MONTH },
  { label: '6 - 12 months', key: experience.SIX_TO_TWELVE_MONTH },
  { label: '1 - 3 years', key: experience.ONE_TO_THREE_YEAR },
  { label: '>3 years', key: experience.MORE_THAN_THREE_YEAR }
]

const optionsInvestments = [
  { label: '$0-2000', key: investment.LESS_THAN_TWO_THOUSAND },
  { label: '$2000-5000', key: investment.TWO_TO_FIVE_THOUSAND },
  {
    label: '$5000-10000',
    key: investment.FIVE_TO_TEN_THOUSAND
  },
  { label: '>$10000', key: investment.MORE_THAN_TEN_THOUSAND }
]

interface NoBussinessProps {
  onChange: (name: string) => (e: any) => void
  state: PublisherRegister
  onSubmitForm: () => void
  isLoading: boolean
}
const NoBussiness = ({ onChange, state, onSubmitForm, isLoading }: NoBussinessProps) => {
  const [error, setError] = useState<boolean>(false)
  const [firstSubmit, setFirstSubmit] = useState<boolean>(false)
  const ref = useRef(null)
  const { fbpTrackViewContentSignupStep2 } = useFbp()
  const { gtagTrackViewContentSignupStep2 } = useGtag()
  const { logRocket } = getLogRocket()

  useEffect(() => {
    if (useCheckDomain()) {
      fbpTrackViewContentSignupStep2()
      gtagTrackViewContentSignupStep2()
      logRocket?.identify({
        email: state.email,
        firstName: state.first_name,
        lastName: state.last_name
      })
    }
  }, [])
  useEffect(() => {
    const form = ref?.current as any
    if (!form) {
      return
    }
    const _error = form.querySelector('.error-message')
    if (_error) {
      form.querySelector('.error-control').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
    }
    setError(_error)
  })

  const onSubmit = async () => {
    if (!firstSubmit) {
      setFirstSubmit(true)
      const error = await new Promise((resolve) => {
        setTimeout(() => {
          setError((error) => {
            resolve(error)
            return error
          })
        }, 0)
      })
      if (error) {
        return
      }
    }
    onSubmitForm()
  }

  return (
    <>
      {' '}
      <div className="signup-form" ref={ref}>
        <Loading isLoading={isLoading} isFullWidth />
        <h1 className="h6 mb-4" style={{ textAlign: 'center' }}>
          <div className="icon-responsive">
            <p>
              <Icon
                src={iconPath('checkmark_circle_filled')}
                className="icon mr-2 "
                fill="var(--primary-100)"
                size="24px"
              />
            </p>
            Just a few questions to finish setting up your account
          </div>
        </h1>

        <div className="col-12 mb-3 experience-choice ">
          <ValidateControl
            title="1. What has been your experience with Facebook advertising?"
            require
            value={state?.experience ?? ''}
            firstSubmit={firstSubmit}
            editor={
              <div className="col-12 d-flex align-items-center mt-2 ">
                <ChoiceGroup
                  onChange={onChange('experience')}
                  value={state?.experience ?? ''}
                  options={optionsExperiences}
                />
              </div>
            }
          />
        </div>

        <div className="col-12 mb-3 invesments-choice ">
          <ValidateControl
            title="2. How much would you like to invest and start an ecommerce business?"
            require
            value={state?.investment ?? ''}
            // onChange={onChange('own_ecommerce_business')}
            firstSubmit={firstSubmit}
            editor={
              <div className="col-12 d-flex align-items-center mt-2 ">
                <ChoiceGroup
                  onChange={onChange('investment')}
                  value={state?.investment ?? ''}
                  options={optionsInvestments}
                  //   className="d-flex justify-content-between"
                />
              </div>
            }
          />
        </div>

        <Button
          type="primary"
          className="my-4 subtitle-2"
          width="100%"
          style={{ height: '48px' }}
          onClick={onSubmit}
          disabled={error}
        >
          Finish Signing Up
        </Button>
        <style jsx>{style}</style>
      </div>
    </>
  )
}

const style = css`
  .signup-form {
    padding: 32px;
    box-shadow: var(--depth-16);
    background-color: var(--white-100);
    border-radius: 16px;
    max-width: 650px;
    margin: auto;
  }
  .btn-finish {
    height: 48px;
  }
  :global(body .experience-choice .p-inputgroup, body .experience-choice .p-inputgroup:hover, body
      .experience-choice
      .p-inputgroup.focus, body .invesments-choice .p-inputgroup, body .invesments-choice .p-inputgroup:hover, body
      .invesments-choice
      .p-inputgroup.focus) {
    border: none !important;
    box-shadow: none !important;
    transition: none;
  }
  :global(.choice-group) {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  :global(.experience-choice .p-inputgroup .p-field-radiobutton .p-radiobutton .p-radiobutton-box) {
    width: 20px;
    height: 20px;
    margin: auto;
  }
  :global(.experience-choice .p-field-checkbox, .experience-choice .p-field-radiobutton, .experience-choice
      .p-field-checkbox, .experience-choice .p-field-radiobutton) {
    width: 100%;
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    color: var(--gray-8);
  }
  :global(.invesments-choice .p-field-checkbox, .invesments-choice .p-field-radiobutton, .invesments-choice
      .p-field-checkbox, .invesments-choice .p-field-radiobutton) {
    width: 100%;
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    color: var(--gray-8);
  }
  :global(.p-field-radiobutton .p-radiobutton .p-radiobutton-box) {
    width: 20px;
    height: 20px;
    margin: auto;
  }

  @media only screen and (min-width: 500px) {
    .e-commerce-style {
      display: flex;
      align-items: center;
    }

    .row-input-responsive {
      display: flex;
      width: 50%;
    }
  }

  @media only screen and (min-width: 620px) {
    .confirm-checkbox {
      display: flex;
    }

    :global(.experience-choice .p-field-checkbox, .experience-choice .p-field-radiobutton, .experience-choice
        .p-field-checkbox, .experience-choice .p-field-radiobutton) {
      width: 33%;
      font-weight: 500;
      font-size: 13px;
      line-height: 24px;
      color: var(--gray-8);
    }

    :global(.invesments-choice .p-field-checkbox, .invesments-choice .p-field-radiobutton, .invesments-choice
        .p-field-checkbox, .invesments-choice .p-field-radiobutton) {
      width: 25%;
      font-weight: 500;
      font-size: 13px;
      line-height: 24px;
      color: var(--gray-8);
    }
    .icon-responsive {
      display: flex;
      align-items: center;
    }
  }
`

export default NoBussiness
